import { render, staticRenderFns } from "./HousingDemand.vue?vue&type=template&id=c989d3ae&scoped=true"
import script from "./HousingDemand.vue?vue&type=script&lang=js"
export * from "./HousingDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989d3ae",
  null
  
)

export default component.exports